import { render, staticRenderFns } from "./PowerOfAttorneyAndProofOfInterest.vue?vue&type=template&id=6d423dd8&scoped=true&"
import script from "./PowerOfAttorneyAndProofOfInterest.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyAndProofOfInterest.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyAndProofOfInterest.vue?vue&type=style&index=0&id=6d423dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d423dd8",
  null
  
)

export default component.exports